import React, {useContext, useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
import styles from "./processCompareSidebar/ProcessCompareSidebar.module.scss";
import ProcessCompareSidebarColorPicker from "./processCompareSidebar/ProcessCompareSidebarColorPicker";
import AddNewLayer from "./processCompareSidebar/AddNewLayer";
import ProcessCompareSidebarRename from "./processCompareSidebar/ProcessCompareSidebarRename";
import ProcessCompareFiltersDetail from "./processCompareSidebar/ProcessCompareFiltersDetail";
import appContext from "../../../../context/appContext";
import apiProcessCompareAutoSave from "../../../../services/api/apiProcessCompareAutoSave";
import http from "../../../../services/api/utilities/http";

const ProcessCompareSidebar = () => {

    const context = useContext(appContext);

    const [selectedIds, setSelectedIds] = useState([]);
    const [showNewLayerPopup, setShowNewLayerpopup] = useState(false);
    const [selectedAnalysisId, setSelectedAnalysisId] = useState({});
    const [layerCounter, setLayerCounter] = useState(0);
    const [selectedLayerForCompare, setSelectedLayerForCompare] = useState(null);
    const [sidebarData, setSidebarData] = useState([]);
    const [canCallGetAutoSaveData, setCanCallGetAutoSaveData] = useState(null);
    const [lastActiveLayer, setLastActiveLayer] = useState(null);

    let contextUid = null;
    if (context.handleUid().id) {
        contextUid = context.handleUid().id;
    } else {
        contextUid = JSON.parse(localStorage.getItem('mapData')).id;
    }

    useEffect(() => {
        if (sidebarData.length) {
            if (context.handleCompareId()) {
                setSelectedLayerForCompare(context.handleCompareId());
            } else {
                setSelectedLayerForCompare(sidebarData?.find(item => item.type !== "mainLayer")?.layer)
            }
        }
    }, [context.handleCompareId(), sidebarData]);

    const staticSidebarOptionMenus = [
        {
            layer_name: 'Remove This Layer',
            type: 'mainOption',
            icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.1042 7.89017C16.1042 7.89017 15.6517 13.5027 15.3892 15.8668C15.2642 16.996 14.5667 17.6577 13.4242 17.6785C11.25 17.7177 9.07332 17.7202 6.89999 17.6743C5.80082 17.6518 5.11499 16.9818 4.99249 15.8727C4.72832 13.4877 4.27832 7.89017 4.27832 7.89017" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17.2567 5.19975H3.125" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14.5335 5.19975C13.8793 5.19975 13.316 4.73725 13.1877 4.09642L12.9852 3.08308C12.8602 2.61558 12.4368 2.29225 11.9543 2.29225H8.42682C7.94432 2.29225 7.52099 2.61558 7.39599 3.08308L7.19349 4.09642C7.06516 4.73725 6.50182 5.19975 5.84766 5.19975" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        },
        {
            layer_name: 'Change Color',
            type: 'mainOption',
            icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.1668 9.99999C14.1668 12.3012 12.3013 14.1667 10.0002 14.1667C7.69898 14.1667 5.8335 12.3012 5.8335 9.99999C5.8335 7.69881 7.69898 5.83333 10.0002 5.83333C12.3013 5.83333 14.1668 7.69881 14.1668 9.99999Z" stroke="#0A195C" stroke-width="1.5"/>
                <path d="M15.2598 4.74028L15.3572 4.64286M4.64286 15.3572L4.74027 15.2598M10 2.56162V2.5M10 17.5V17.4384M2.56162 10H2.5M17.5 10H17.4384M4.74026 4.74028L4.64284 4.64286M15.3571 15.3571L15.2598 15.2598" stroke="#363853" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>,
            children: [
                {
                    layer_name: 'Colors',
                    content: "ProcessCompareSidebarColorPicker",
                }
            ]
        },
        {
            layer_name: 'Rename',
            type: 'mainOption',
            icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.4165 16.5818H16.7307" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.7126 4.12975C11.3268 3.34725 12.3193 3.38809 13.1026 4.00225L14.2609 4.91059C15.0443 5.52475 15.3218 6.47725 14.7076 7.26142L7.80009 16.0739C7.56926 16.3689 7.21676 16.5431 6.84176 16.5473L4.17759 16.5814L3.57426 13.9856C3.48926 13.6214 3.57426 13.2381 3.80509 12.9423L10.7126 4.12975Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.41895 5.78009L13.4139 8.91176" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>,
            children: [
                {
                    layer_name: 'Rename',
                    content: "ProcessCompareSidebarRename"
                }
            ]
        },
        {
            layer_name: 'Filters Detail',
            type: 'mainOption',
            icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.74427 18.3333L11.7245 16.4599V11.5503L17.9659 5.22047C18.2011 4.98329 18.3332 4.65778 18.3332 4.3169V2.93129C18.3332 2.23224 17.7846 1.66667 17.1078 1.66667H2.89191C2.21506 1.66667 1.6665 2.23224 1.6665 2.93129V4.34858C1.6665 4.67026 1.78458 4.97945 1.99749 5.21375L7.74427 11.5503V18.3333Z" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>,
            children: [
                {
                    layer_name: 'Filters Detail',
                    content: "ProcessCompareFiltersDetail"
                }
            ]
        },
        {
            layer_name: 'Go to Analysis',
            type: 'mainOption',
            icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7082 13.6117V6.38758C17.7082 3.87092 15.9257 2.29175 13.4032 2.29175H6.5965C4.074 2.29175 2.2915 3.86258 2.2915 6.38758L2.2915 13.6117C2.2915 16.1367 4.074 17.7084 6.5965 17.7084H13.4032C15.9257 17.7084 17.7082 16.1367 17.7082 13.6117Z" stroke="#200E32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.4047 10.0001H6.59473" stroke="#200E32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.2686 6.87675L13.4052 10.0001L10.2686 13.1234" stroke="#200E32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        }
    ];

    useEffect(() => {
        getLayersData();
    }, []);

    const handleHelpInfoBox = id => {
        const meetAnalysis = JSON.parse(localStorage.getItem("meetAnalysis")) || [];
        if (id) {
            if (!meetAnalysis || !meetAnalysis.includes(id)) {
                meetAnalysis.push(id);
                localStorage.setItem("meetAnalysis", JSON.stringify(meetAnalysis));
            }
        }
    }

    useEffect(() => {
        return () => {
            handleHelpInfoBox(contextUid);
        }
    },[]);

    const getLayersData = () => {
        const mainLayerData = context.handleAnalysis().find(item => item.id === contextUid)
        if (mainLayerData) {
            http.get(`process_mining/process_compare_layers/?base_analysis=${contextUid}`)
                .then(res => {
                    let data = res.data.data.map(item => ({...item, type: 'layer', children: staticSidebarOptionMenus}));
                    const mainLayerOptions = [staticSidebarOptionMenus[3]];
                    data.push({
                        base_analysis: contextUid,
                        layer: contextUid,
                        layer_name: mainLayerData?.name,
                        layer_number: 'Main Layer',
                        type: 'mainLayer',
                        color: '#8A0FFF',
                        children: mainLayerOptions,
                    });
                    setSidebarData(data);
                })
                .catch(err => {
                    console.log(err.response)
                })
        }
    }

    useEffect(() => {
        return () => {
            context.handleLayerList([])
        }
    }, [])

    const list = context?.handleLayerList()
    useEffect(() => {
        if (list.length && canCallGetAutoSaveData === false && !context.handleIsFiltersModalOpen()) {
            const token = localStorage.getItem('token');
            const copyData = [...context?.handleLayerList()]
            const newData = copyData?.map(item => {
                delete item.children
                return item
            })
            apiProcessCompareAutoSave.postSingle(contextUid, {data: newData}, token).then(res => {

            })
              .catch(err => {
                  console.log(err);
              })
        }
    }, [list, context.handleIsFiltersModalOpen()])

    useEffect(() => {
        if (selectedIds.length > 0) {
            setShowNewLayerpopup(false);
        }
    }, [selectedIds]);

    const sidebar = context.handleLayerList()

    useEffect(() => {
        const selectedLayerId = context?.handleLayerList()?.length && context?.handleLayerList()?.find(item => item.selected)?.layer
        if(selectedLayerId) {
            context.handleCompareId(selectedLayerId)
            const layer = sidebarData.find(item => item.layer === selectedLayerId);

            if (layer) {
                context.handleCompareColor(layer.color)
            }
        }
    }, [sidebarData , sidebar]);

    useEffect(() => {
        if (canCallGetAutoSaveData === null) {
            setCanCallGetAutoSaveData(true)
        }
    }, [sidebarData, selectedLayerForCompare])

    useEffect(() => {
        if (canCallGetAutoSaveData) {
            const mainLayerData = context.handleAnalysis().find(item => item.id === contextUid)
            const token = localStorage.getItem('token');
            apiProcessCompareAutoSave.getSingle(contextUid, token).then(res => {
                const mainLayer = {
                    base_analysis: contextUid,
                    layer: contextUid,
                    layer_name: mainLayerData?.name,
                    layer_number: 'Main Layer',
                    type: 'mainLayer',
                    color: '#8A0FFF',
                    selected: false,
                    appliedFilters: {
                        variants: [1],
                        active_variants: [1]
                    }
                }
                const result = res.response.data.data.saved_data?.length ? res.response.data.data.saved_data : []

                const mainLayerFilters = result.find(item => item.type === "mainLayer")?.appliedFilters
                const secondLayerFilters = result.find(item => item.selected && !item.type)?.appliedFilters
                if (result.find(item => item.type === "mainLayer")) {
                    context.handleLayerList(result)
                } else {
                    context.handleLayerList([mainLayer, ...result])
                }

                if (context.handleIsFiltersModalOpen() === false) {
                    context.selectFilter({
                        "layer1_filters": mainLayerFilters || {
                            variants: [1],
                            active_variants: [1]
                        },
                        "layer2_filters": secondLayerFilters || {
                            variants: [1],
                            active_variants: [1]
                        },
                    })

                    context.actionFilter("fetching")
                    setCanCallGetAutoSaveData(false)
                }
            })
              .catch(err => {
                  console.log(err);
              })
        }
    }, [canCallGetAutoSaveData])

    const handleClick = (e, selected, layerNum = null, id = null, depthLevel) => {
        if (e) {
            e.stopPropagation();
        }
        let updatedArray = selectedIds.slice(0);
        const findEl = updatedArray.find(item => item === selected);
        if (findEl) {
            updatedArray = updatedArray.filter(item => item !== findEl);
        } else {
            if (depthLevel === 0) {
                updatedArray = [selected];
                setSelectedAnalysisId(id);
            } else {
                updatedArray[depthLevel] = selected;
            }
        }
        setSelectedIds(updatedArray);
    }

    const handleCloseStep = () => {
        handleClick(null, selectedIds[selectedIds.length - 1], null, null, 1);
    }

    const handleRemove = (id) => {
        let r = window.confirm("Are You Sure?");
        if (r === true) {
            http.delete(`process_mining/process_compare_layers/${id}/?base_analysis=${contextUid}`)
                .then(res => {
                    const filteredData = sidebarData.filter(item => item.id !== id);
                    setSidebarData(filteredData);
                    const filteredContextData = context.handleLayerList()?.filter(item => item.id !== id)
                    context.handleLayerList(filteredContextData)
                    const resFindSearch = filteredData.some(item => item.layer === selectedLayerForCompare)
                    if (!resFindSearch) {
                        if (filteredData.length > 1) {
                            setSelectedLayerForCompare(filteredData[filteredData.length - 2].layer);
                        } else {
                            setSelectedLayerForCompare(filteredData[filteredData.length - 1].layer);
                        }
                    }
                })
                .catch(err => {
                    console.log(err.response);
                })
        }
    }

    const handleEdit = (type, layer, id, data) => {
        http.patch(`process_mining/process_compare_layers/${id}/?base_analysis=${contextUid}`)
            .then(res => {
                if (type === 'rename') {
                    const newArr = sidebarData.map(item => {
                        if (item.layer === layer) {
                            return {...item, layer_name: data.layer_name, layer_number: data.layer_number}
                        } else {
                            return item
                        }
                    });
                    const newContextArr = context.handleLayerList().map(item => {
                        if (item.layer === layer) {
                            return {...item, layer_name: data.layer_name, layer_number: data.layer_number}
                        } else {
                            return item
                        }
                    });
                    setSidebarData(newArr);
                    context.handleLayerList(newContextArr)
                } else if (type === 'changeColor') {
                    const newArr = sidebarData.map(item => {
                        if (item.layer === layer) {
                            return {...item, color: data.color}
                        } else {
                            return item
                        }
                    });
                    const newContextArr = context.handleLayerList().map(item => {
                        if (item.layer === layer) {
                            return {...item, color: data.color}
                        } else {
                            return item
                        }
                    });
                    setSidebarData(newArr);
                    context.handleCompareColor(data.color)
                    context.handleLayerList(newContextArr)
                }
            })
            .catch(err=>{
                console.log(err.response);
            })
    }

    const handleChangeColor = (info) => {
        handleEdit('changeColor', info.layer, info.id, {color: info.color});
    }

    const handleRename = (info) => {
        handleEdit('rename', info.layer, info.id, {layer_name: info.layer_name, layer_number: info.layer_number});
    }

    const Components = {
        ProcessCompareSidebarRename: <ProcessCompareSidebarRename
            info={sidebarData.find(item => item.layer === selectedAnalysisId)}
            handleCloseStep={handleCloseStep}
            handleRename={(info) => handleRename(info)}
        />,
        ProcessCompareSidebarColorPicker: <ProcessCompareSidebarColorPicker
            info={sidebarData.find(item => item.layer === selectedAnalysisId)}
            handleChangeColor={(info) => handleChangeColor(info)}
            handleCloseStep={handleCloseStep}
        />,
        ProcessCompareFiltersDetail: <ProcessCompareFiltersDetail
            info={sidebarData.find(item => item.layer === selectedAnalysisId)}
        />
    }

    const handleClickOnItem = (type, title, layerNum, id, depthLevel) => {
        const copySidebarData = context?.handleLayerList()?.length ? [...context.handleLayerList()] : []
        const newSidebarData = copySidebarData.map(item => {
            if (item.layer === id) {
                return {...item, selected: true}
            } else {
                return {...item, selected: false}
            }
        })
        if (depthLevel === 0) {
            context.handleLayerList(newSidebarData)
        }
        if (type === 'layer') {
            setSelectedLayerForCompare(id);
            setSelectedAnalysisId(id);
        } else if (type === 'mainOption') {
            handleClick(null, title, null, null, depthLevel)
        }
    }

    useEffect(() => {
        if (selectedLayerForCompare) {
            handleClickOnItem("layer", null, null, selectedLayerForCompare)
        }
    }, [selectedLayerForCompare])


    useEffect(() => {
        if (!context.handleIsFiltersModalOpen() && context.handleLayerList()?.length) {
            setSelectedLayerForCompare(context.handleLayerList()?.[0].layer)
            const copySidebarData = context?.handleLayerList()?.length ? [...context.handleLayerList()] : []
            let lastActive = lastActiveLayer
            if (!lastActive) {
                lastActive = context.handleLayerList()?.[0].layer
            }
            if (context.handleLayerList()?.find(item => item.selected)?.type === "mainLayer") {
                const newSidebarData = copySidebarData.map(item => {
                    if (item.layer === lastActive) {
                        return {...item, selected: true}
                    } else {
                        return {...item, selected: false}
                    }
                })
                context.handleLayerList(newSidebarData)
            }
        }
    },[context.handleIsFiltersModalOpen()]);

    const history = useHistory();
    const handleRedirectToProcessMap = (item) => {
        context.handleAutoSave(
            {
                processMapFilters: [],
                processMapVariants:[1],
                processCompareVariants:false,
                processCompareFilters:[]
            }
        )
        context.handleUid({id:item.id,uid:item.uid,name:item.name});
        localStorage.setItem('variant-explorer',JSON.stringify({uid:item.id,name:item.name}))
        // localStorage.setItem('mapData',JSON.stringify({uid:item.idname:item.name}))
        saveTabs()
        getTabs(item.id)
    }

    const saveTabs = () => {
        const openTabs = context.openTabs
        let id = context.handleUid().id
        http.post('process_mining/save_tabs_state/'+id,
            {
                'tabs_config': {openTabs,activeTab:'/process-compare'},
            }).then(()=>{

        })
    }
    const getTabs = (id) => {

        let token = localStorage.getItem('token')
         // id = context.handleUid().id ?  context.handleUid().id : JSON.parse(localStorage.getItem('mapData')).id
        http.get('process_mining/save_tabs_state/' + id)
            .then(res => {
                const state = res.data.data.tabs_config;
                if (state.openTabs) {
                    let tabs = state.openTabs
                    let tab = tabs.find(tab => tab.link === 'variant-explorer');
                    if(!tab){
                        tabs.push({id:6, title:'Variant Explorer', link:'variant-explorer'})
                    }
                    context.handleAddTab('all', tabs)
                    history.push('/variant-explorer')
                } else {
                    context.handleAddTab(6, 'Variant Explorer', 'variant-explorer');
                    history.push('/variant-explorer')
                }
            })
            .catch(err => {
                console.log(err.response)
            })
    }

    const queryParam = new URLSearchParams(history.location.search).get('view');

    const handleClickOnOption = (layerName) => {
        switch (layerName) {
            case 'Remove This Layer':
                const findData = sidebarData.find(item => item.layer === selectedAnalysisId);
                handleRemove(findData.id);
                break;
            case 'Go to Analysis':
                const findAnalysis = context.handleAnalysis().find(item => item.id === selectedAnalysisId);
                context.dispatch({type:'set_process_compare_version',value: context.state.processCompareSaveVersion});
                handleRedirectToProcessMap({id: findAnalysis.id, uid: findAnalysis.data_pool, name: findAnalysis.name});
                break;
            default:
                break;
        }
    }

    const handleClickOutside = event => {
        if (!event.target.closest(".sidebar-item") && !event.target.closest(".addNewLayer")) {
            handleClick(null, selectedIds[selectedIds.length - 1], null, null, 0)
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

    const handleDrawMenu = (children, depthLevel = 0) => {

        return children.map(subOption => {
            if (!subOption.children) {
                if (subOption.content) {
                    return (<div className={'sidebar-item'}>
                        <div className={`${styles.header} d-flex align-items-center justify-content-between`}>
                            <div className={styles.title}>
                                { subOption.layer_name }
                            </div>
                            <div onClick={handleCloseStep}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="15.834" y1="5.22732" x2="5.22798" y2="15.8333" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
                                    <path d="M4.94434 4.94442L15.786 15.7861" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                        </div>
                        { Components[subOption.content] }
                    </div>)
                } else {
                    return (
                      <div onClick={() => handleClickOnOption(subOption.layer_name)} className={`sidebar-item d-flex align-items-center ${styles.mainOption}`}>
                          {
                              subOption.icon &&
                              <div className={`${styles.optionIcon} d-flex`}>{ subOption.icon }</div>
                          }
                          <div>{ subOption.layer_name }</div>
                      </div>
                    )
                }
            } else {
                return (
                  <>
                      <div className={'relative'}>
                          <div
                              onClick={() => {
                                  setLastActiveLayer(subOption.layer);
                                  handleClickOnItem(subOption.type, subOption.layer_name + subOption.layer, subOption.layer_number, subOption.layer, depthLevel)
                              }}
                              className={[
                                  "sidebar-item",
                                  (subOption.type === "layer" || subOption.type === "mainLayer" ? styles.layer : ''),
                                  (subOption.type === "mainLayer" || (context?.handleLayerList()?.length && subOption.layer === context?.handleLayerList()?.find(item => item.selected)?.layer) ? styles.selected : ''),
                                  (subOption.type === 'mainOption' ? styles.mainOption : ''),
                                  (selectedIds.some(item => item === subOption.layer_name+subOption.layer) ? styles.active : ''),
                                  ((subOption.type === "mainLayer" && queryParam && queryParam === 'side-by-side') ? styles.sideBySideView : '')
                              ].join(' ')}
                          >
                              <div
                                  className={styles.bullet}
                                  style={{backgroundColor: subOption.color}}>
                              </div>
                              <div className={'d-flex align-items-center justify-content-between'}>
                                  <div className={`d-flex align-items-center`}>
                                      {
                                          subOption.icon &&
                                          <div className={`${styles.optionIcon} d-flex`}>{ subOption.icon }</div>
                                      }
                                      <div className={styles.titleWrap}>
                                          <div>{ subOption.layer_number }</div>
                                          <div>{ subOption.layer_name }</div>
                                      </div>
                                  </div>
                                  {
                                      subOption.type === "layer" || subOption.type === "mainLayer" ?
                                          (
                                              <div className={`d-flex align-items-center ${styles.dots}`} onClick={(e) => handleClick(e, subOption.layer_name+subOption.layer, subOption.layer_number, subOption.layer, depthLevel)}>
                                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M11.6667 4.16667C11.6667 3.25 10.9167 2.5 10 2.5C9.08334 2.5 8.33334 3.25 8.33334 4.16667C8.33334 5.08333 9.08334 5.83333 10 5.83333C10.9167 5.83333 11.6667 5.08333 11.6667 4.16667Z" fill="#0A195C"/>
                                                      <path d="M11.6667 15.8333C11.6667 14.9167 10.9167 14.1667 10 14.1667C9.08334 14.1667 8.33334 14.9167 8.33334 15.8333C8.33334 16.75 9.08334 17.5 10 17.5C10.9167 17.5 11.6667 16.75 11.6667 15.8333Z" fill="#0A195C"/>
                                                      <path d="M11.6667 9.99999C11.6667 9.08333 10.9167 8.33333 10 8.33333C9.08334 8.33333 8.33334 9.08333 8.33334 9.99999C8.33334 10.9167 9.08334 11.6667 10 11.6667C10.9167 11.6667 11.6667 10.9167 11.6667 9.99999Z" fill="#0A195C"/>
                                                  </svg>
                                              </div>
                                          ) :
                                          (
                                              <div className={`d-flex align-items-center`}>
                                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                      <path d="M7.0835 4.16667L12.9168 10L7.0835 15.8333" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                  </svg>
                                              </div>
                                          )
                                  }
                              </div>
                          </div>
                          {
                              selectedIds[depthLevel] === subOption.layer_name+subOption.layer &&
                              <div>
                                  <div className={styles.subOptions}>
                                      { handleDrawMenu(subOption.children, depthLevel + 1) }
                                  </div>
                              </div>
                          }
                      </div>
                  </>
                )
            }
        })
    }

    const handleClickAddNewLayer = () => {
        if (selectedIds.length > 0) {
            setSelectedIds([]);
        }
        setShowNewLayerpopup(!showNewLayerPopup);
    }

    const colors = [
        '#FF0053',
        '#FFC700',
        '#0A195C',
        '#70789E',
        '#C2C7ED',
    ];

    const handleAddNewLayer = (option) => {
        setCanCallGetAutoSaveData(false)
        let token = localStorage.getItem('token')
        const data = {
            layer_name: String(option.name),
            layer_number: `Layer ${layerCounter + 1}`,
            color: colors[Math.floor(Math.random() * colors.length)],
            base_analysis: contextUid,
            layer: option.id,
        }
        http.post(`process_mining/process_compare_layers/`,
          data)
        .then(res => {
            setLayerCounter(layerCounter + 1);
            getLayersData();
            setSelectedLayerForCompare(res.data.data.layer);
            const data = context?.handleLayerList()?.length ? context.handleLayerList() : []
            context.handleLayerList([{
                ...res.data.data,
                selected: true,
                appliedFilters: {
                    variants: [1],
                    active_variants: [1]
                }
              }, ...data])
        })
        .catch(err=>{
            console.log(err.response);
        })
    }

    return (
      <div
        className={[styles.ProcessCompareSidebar, (queryParam && queryParam === "side-by-side" ? styles.sideBySideView : '')].join(' ')}
        style={{left: history.location.search === "?view=side-by-side" && 32}}
      >
          <AddNewLayer
            analysisData={context.handleAnalysis()}
            sidebarData={sidebarData}
            onClick={handleClickAddNewLayer}
            handleAddNewLayer={(option) => handleAddNewLayer(option)}
            showNewLayerPopup={showNewLayerPopup}
            handleShowNewLayerPopup={() => setShowNewLayerpopup(!showNewLayerPopup)}
          />
          { handleDrawMenu(sidebarData) }
      </div>
    )
}

export default ProcessCompareSidebar;